import { ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import {
  AddressWithOptionalCoordinates,
  AddressWithOptionalCoordinatesValidationSchema,
  Contact,
  IsValidNumber,
  IsValidString,
  OpeningHours,
} from '@cnx-saas/common';
import { VehicleCapabilities } from '@cnx-saas/vehicles';
import { LocationInput } from '../types';

export class LocationInputValidationSchema implements LocationInput {
  @IsValidString({ optional: true })
  externalReference?: string;

  owned: boolean;

  @ValidateNested()
  @Type(() => AddressWithOptionalCoordinatesValidationSchema)
  address: AddressWithOptionalCoordinates;

  @IsValidString({ optional: true })
  company?: string;

  contact?: Contact;

  @IsValidString({ optional: true })
  description?: string;

  loadingRequirements?: VehicleCapabilities[];

  @IsValidNumber({ integer: true })
  serviceTime: number;

  openingHours: OpeningHours;
}
